export const ZONE_IDS_PB = {
  PROG_BANNER: '946048',
  HOUSE_BANNER: '679340',
  PROG_HOMEPAGE_BANNER: '962468',
  PROG_PLAYERS_BANNER: '962469',
  PROG_PLAYERS_DETAILS_BANNER: '962470',
  PROG_WATCH_NOW_BANNER: '962471',
  PROG_RANKINGS_BANNER: '962472',
  PROG_RESULTS_BANNER: '962473',
  HOUSE_SMALL_CARD: '679331',
  PROG_SMALL_CARD: '962474',
  HOUSE_LONG_CARD: '679332',
  PROG_LONG_CARD: '962475',
  FLOATING_VIDEO: '940896',
  HOMEPAGE_VIDEO: '949638',
  CONTENT_VIDEO: '962477',
  HOUSE_MODAL: '809175',
} as const;

export const ZONE_IDS_PL = {
  PROG_BANNER: '962487',
  HOUSE_BANNER: '962488',
  PROG_LEAGUES_BANNER: '962489',
  HOUSE_LEAGUES_CARD: '688401',
} as const;

export const ZONE_IDS_APR = {
  PROG_BANNER: '962490',
  HOUSE_BANNER: '962491',
  PROG_WPR_BANNER: '962492',
} as const;

export interface PlacementInterface {
  banner_id: string;
  width: string;
  height: string;
  alt_text: string;
  accompanied_html: string;
  target: string;
  tracking_pixel: string;
  body: string; // will be empty string for image ads, else for video ads it will have unicode escaped string of script(s)
  redirect_url: string;
  refresh_url: string;
  rct: string;
  rcb: string;
  refresh_time: string;
  placement_id: string;
  user_frequency_views: string;
  user_frequency_start: string;
  user_frequency_expiry: string;
  viewable_url: string;
  eligible_url: string;
  is_redirectable: boolean;
  image_url: string;
  impressions_remaining: number;
  has_quota: boolean;
  accupixel_url: string;
  user_sync: AdEmbed[];
}

type AdEmbed = {
  demand_source: string; // 'adbutler' | 'minutemedia'
  type: 'image' | 'iframe';
  url: string;
};
